export const sortFieldOptions = [
    { value: 'productiondate', label: 'Productiedatum' },
    { value: 'productnr', label: 'Productnr' },
    { value: 'ordernr', label: 'Ordernr' },
    { value: 'customer', label: 'Klant' },
    { value: 'reference', label: 'Referentie' },
    { value: 'producttype', label: 'Producttype' },
    { value: 'ralnr', label: 'Ralnr' },
    { value: 'raltype', label: 'Raltype' },
    { value: 'status', label: 'Status' },
    { value: 'deliverydateid', label: 'Ritnr' },
    { value: 'deliverymethod', label: 'Leveringsmethode' },
    { value: 'deliveryDateIN', label: 'Leveringsdatum IN' },
    { value: 'deliverydate', label: 'Leveringsdatum UIT' },
    { value: 'supplierId', label: 'Leverancier' },
];

export const sortOrderOptions = [
    { value: 'ASC', label: 'Oplopend' },
    { value: 'DESC', label: 'Aflopend' },
];

export const specialFilterOptions = [
    { value: 'noFilter', label: 'Geen filter' },
    { value: 'pastDueFilter', label: 'In buffertijd' },
    { value: 'recalculatedFilter', label: 'Aangepaste leverdatum' },
    { value: 'finishedFilter', label: 'Toon ook afgewerkte producten' },
    { value: 'eosolFilter', label: 'Groothandel klanten' },
    { value: 'mmFilter', label: 'Particuliere klanten' },
];

export const clearedFilters = {
    finished: 0,
    productnr: '',
    ordernr: '',
    customer: '',
    reference: '',
    producttype: 0,
    ralnr: '',
    raltype: '',
    status: '',
    productionDate: '',
    deliveryDateId: '',
    deliveryMethod: '',
    sortField: sortFieldOptions[0].value,
    sortOrder: sortOrderOptions[0].value,
    specialFilter: specialFilterOptions[0].value,
    supplierId: -1,
    deliveryDateIN: '',
    deliveryDate: '',
};
